var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5744 49L65.6294 35.9056L52.5 22.75L52.5744 49Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.272 39.5718L57.2688 39.5586L57.2732 30.5986L26.2763 30.6118L26.272 39.5718Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19625 30.625L2.1875 39.3531",
    stroke: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9463 30.625L10.9375 39.3531",
    stroke: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6962 30.625L19.6875 39.3531",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.656151c8b7f2e78800ffd059a92a3120.svg";
export { ForwardRef as ReactComponent };